module.exports = __webpack_public_path__ + "static/media/libro.4dc54c6f.svg";